import { render, staticRenderFns } from "./WarehousesPage.vue?vue&type=template&id=63bf05be"
import script from "./WarehousesPage.vue?vue&type=script&lang=js"
export * from "./WarehousesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports